import {Helmet} from 'react-helmet';
import {generatePath} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {FilterObject} from 'nutshell-core/types';

import {headTitle} from 'shells/document/head-title';

import type {FormPublishInput, FormUpdateInput} from 'nutshell-graphql-types';

import type {ReportURLParams} from '../../../reports/report-types';

import {usePublishForm} from '../../graphql/graphql-wrappers/use-publish-form';

import {MultiPageFormPageContent} from './form-page-content';
import {FullPageFormEditor} from './full-page-form-editor';
import {useGetMultiPageForm} from './graphql/hooks/use-get-multi-page-form';
import {useUpdateMultiPageForm} from './graphql/hooks/use-update-multi-page-form';

type Props = ContextRouter & {
    id: string;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    onParamPush: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    onRemoveAllFilters: () => void;
};

export function FormHomePage(props: Props) {
    const {history, location, match} = props;
    const activeTab = props.match.params.tab;

    const {form, refetch, error, isLoading} = useGetMultiPageForm({formId: props.id});
    const publishForm = usePublishForm();
    const {updateMultiPageForm} = useUpdateMultiPageForm();

    const setSelectedTab = (newTab: string) => {
        const newPath = generatePath(props.match.path, {
            formId: props.match.params.formId,
            tab: newTab,
        });

        history.push({
            pathname: newPath,
            search: history.location.search,
        });
    };

    return (
        <>
            <Helmet>
                <title>{headTitle(form ? `Form • ${form.name}` : 'Form')}</title>
            </Helmet>
            {activeTab === 'editor' && form ? (
                <FullPageFormEditor
                    history={history}
                    location={location}
                    match={match}
                    form={form}
                    updateMultiPageForm={updateMultiPageForm}
                    onPublishForm={(input: FormPublishInput) => publishForm(input)}
                    onClose={() => setSelectedTab('main')}
                    refetchForm={() => refetch()}
                />
            ) : (
                <MultiPageFormPageContent
                    {...props}
                    form={form}
                    error={error}
                    isLoading={isLoading}
                    activeTab={activeTab || 'main'}
                    onSetSelectedTab={(newTab: string) => setSelectedTab(newTab)}
                    activeFilters={props.activeFilters}
                    onParamChange={props.onParamChange}
                    onParamPush={props.onParamPush}
                    urlParams={props.urlParams}
                    onRemoveAllFilters={props.onRemoveAllFilters}
                    onUpdateForm={(input: FormUpdateInput) =>
                        updateMultiPageForm(input).then((res) => res?.data?.formUpdate?.form)
                    }
                    refetchForm={() => refetch()}
                />
            )}
        </>
    );
}
